import dayjs from "dayjs";
import { BulkManifestShipment } from "../../hooks/react-query/useBulkManifestShipments";

export const mockBulkManifestShipments = {
  default: [
    {
      shipmentId: 132443834,
      proNumber: "147363543",
      tags: ["APTR", "DTCL", "LG"],
      serviceDue: null,
      pickupDate: dayjs("2024-08-29T04:00:00"),
      tripNumber: 3025304,
      shipperName: "NATIONAL PUBLIC SEATING @ECONOMY FRT",
      shipperZipCode: "07014",
      consigneeName: "DELTA PARTY RENTAL",
      consigneeZipCode: "38732",
      weight: 460,
      pallets: 1,
      pieces: 0,
      revenue: 351.05,
      originSicCode: "ATB-SEFL",
      destinationSicCode: "ATL",
      currentSicCode: "ATB-SEFL",
      originSic: {
        id: 1,
        code: "ATM",
        ownership: "V",
        lhRegionId: 4,
        timeZone: null,
      },
      destinationSic: {
        id: 18,
        code: "ATL",
        ownership: "V",
        lhRegionId: null,
        timeZone: null,
      },
      currentSic: {
        id: 164,
        code: "ATM",
        ownership: "V",
        lhRegionId: null,
        timeZone: null,
      },
      status: "CARV",
      timeOnDock: null,
    },
    {
      shipmentId: 132439221,
      proNumber: "148398555",
      tags: ["APTR", "RESI", "LG", "DTCL"],
      serviceDue: null,
      pickupDate: dayjs("2024-08-29T04:00:00"),
      tripNumber: 3025304,
      shipperName: "CURATE EAST",
      shipperZipCode: "11040",
      consigneeName: "NICHOLAS HERGA",
      consigneeZipCode: "31411",
      weight: 150,
      pallets: 1,
      pieces: 0,
      revenue: 342.92,
      originSicCode: "EWR",
      destinationSicCode: "ATL",
      currentSicCode: "ATM",
      originSic: {
        id: 1,
        code: "EWR",
        ownership: "V",
        lhRegionId: 4,
        timeZone: null,
      },
      destinationSic: {
        id: 18,
        code: "ATL",
        ownership: "V",
        lhRegionId: null,
        timeZone: null,
      },
      currentSic: {
        id: 164,
        code: "ATM",
        ownership: "V",
        lhRegionId: null,
        timeZone: null,
      },
      status: "CARV",
      timeOnDock: null,
    },
  ],
} as const satisfies Record<string, BulkManifestShipment[]>;
